import { APIGET, APIPOST } from '@/util/http'
import { md5 } from 'js-md5'

export function postLogin(username, pwd) {
  return APIPOST(`login/admin`, {
    username,
    pwd: md5(pwd)
  })
}

export function changePwd(oldPwd, newPwd) {
  return APIPOST(`account/changedPwd`, {
    newPwd: md5(newPwd),
    oldPwd: md5(oldPwd)
  })
}

export function getUserInfo() {
  return APIGET(`account/getInfo`)
}
